<svg fill="none" height="16" viewBox="0 0 15 16" width="15" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.39999 7.60168C9.46665 7.60168 11.2 5.93502 11.2 3.80169C11.2 1.73502 9.53332 0.00168804 7.39999 0.00168804C5.26665 -0.0649786 3.53332 1.60169 3.53332 3.73502C3.53332 5.86835 5.26665 7.60168 7.39999 7.60168Z"
          fill="#009DD6"/>
    <path d="M14.1333 15.935H0.666666C0.266667 15.935 0 15.6684 0 15.2684V13.535C0 11.0684 1.93333 9.06836 4.46666 9.06836H10.3333C12.7333 9.06836 14.8 11.0017 14.8 13.535V15.2684C14.7333 15.6684 14.4 15.935 14.1333 15.935Z"
          fill="#009DD6"/>
</svg>
